(()=>{
function init(root){
root.querySelectorAll('[data-hv-menu-toggle]').forEach(button=>{
if(button.dataset.ready)return;button.dataset.ready='true';button.hidden=false;
const header=button.closest('.hv-header'),nav=header.querySelector('.hv-nav');header.dataset.mobileMenu='ready';
const close=()=>{button.setAttribute('aria-expanded','false');header.dataset.menuOpen='false';};
button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));header.dataset.menuOpen=String(open);});
nav.addEventListener('click',e=>{if(e.target.closest('a'))close();});
header.addEventListener('keydown',e=>{if(e.key==='Escape'){close();button.focus();}});
});
root.querySelectorAll('[data-hv-product]').forEach(section=>{
if(section.dataset.initialized)return;
section.dataset.initialized='true';
const track=section.querySelector('[data-hv-gallery-track]');
const thumbs=[...section.querySelectorAll('[data-hv-image]')];
if(track){
const slides=[...track.querySelectorAll('.hv-gallery-slide')];
const mobile=matchMedia('(max-width: 760px)');let active=0,frame;
const mark=index=>{active=Math.max(0,Math.min(slides.length-1,index));slides.forEach((slide,i)=>slide.classList.toggle('is-active',i===active));thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===active)));};
const go=index=>{mark(index);if(mobile.matches)track.scrollTo({left:active*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
thumbs.forEach((button,i)=>button.addEventListener('click',()=>go(i)));
track.addEventListener('scroll',()=>{if(!mobile.matches)return;cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{if(track.clientWidth)mark(Math.round(track.scrollLeft/track.clientWidth));});},{passive:true});
track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(active+(event.key==='ArrowRight'?1:-1));}});
const resize=new ResizeObserver(()=>{if(mobile.matches)track.scrollTo({left:active*track.clientWidth,behavior:'instant'});});resize.observe(track);
}
const update=()=>{
const selected=section.querySelector('input[name="id"]:checked');
if(!selected)return;
section.querySelectorAll('[data-hv-price]').forEach(item=>item.textContent=selected.dataset.price);
section.querySelectorAll('[data-hv-pack]').forEach(item=>item.textContent=selected.dataset.title);
section.querySelectorAll('[data-hv-atc]').forEach(button=>button.disabled=selected.dataset.available!=='true');
if(location.pathname.includes('/products/')){const url=new URL(location.href);url.searchParams.set('variant',selected.value);history.replaceState(null,'',url);}
};
section.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',update));
update();
const form=section.querySelector('form[action*="/cart/add"]');
if(form)form.addEventListener('submit',async event=>{
const addon=section.querySelector('[data-hv-addon]');
if(!addon?.checked)return;
event.preventDefault();
if(form.dataset.busy)return;
const selected=section.querySelector('input[name="id"]:checked');
if(!selected||selected.dataset.available!=='true')return;
form.dataset.busy='true';
const error=section.querySelector('[data-hv-cart-error]');
error.hidden=true;
section.querySelectorAll('[data-hv-atc]').forEach(b=>b.disabled=true);
form.setAttribute('aria-busy','true');
try{
const response=await fetch(section.dataset.hvAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selected.value,quantity:1},{id:addon.value,quantity:1}]})});
const result=await response.json();
if(!response.ok)throw new Error(result.description||section.dataset.hvError);
location.assign(section.dataset.hvCartUrl);
}catch(e){error.textContent=section.dataset.hvError;error.hidden=false;delete form.dataset.busy;form.removeAttribute('aria-busy');update();}
});
});
root.querySelectorAll('[data-hv-countdown]').forEach(section=>{
if(section.dataset.initialized)return;
section.dataset.initialized='true';
const deadline=Date.parse(section.dataset.deadline);
const tick=()=>{
const remaining=Math.max(0,Math.floor((deadline-Date.now())/1000));
const expired=!Number.isFinite(remaining)||remaining===0;
section.querySelectorAll('[data-count-active]').forEach(el=>el.hidden=expired);
section.querySelector('[data-count-finished]').hidden=!expired;
if(expired)return false;
const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
Object.entries(values).forEach(([unit,value])=>section.querySelector('[data-count-'+unit+']').textContent=String(value).padStart(2,'0'));
return true;
};
if(tick()){const timer=setInterval(()=>{if(!section.isConnected||!tick())clearInterval(timer);},1000);}
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
})();

